import styled from "styled-components";

interface IDivColumStatus {
  status: string;
}
export const DivStatusCommon = styled.div<IDivColumStatus>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else if (status === "neutral") {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    } else if (status === "serving") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else {
      color = props.theme.colors.orangeText;
      backgroundColor =
        props.theme.colors.orangeText + props.theme.transparencies.p10;
    }
    return `
        background-color: ${backgroundColor};
        color: ${color};
        font-family: ${props.theme.fontFamilies.primaryFont};
        font-size: 1.1rem;
        padding: 0.6rem;
      `;
  }}

  align-items: center;
  display: flex;
  font-size: 1.1rem;
  height: 2.5rem;
  justify-content: center;
`;
